const initQualityConstruction = () => {
    const acc = document.getElementById("qcAccordion");
    if (!acc) return;
    const panels = Array.from(acc.querySelectorAll(".accordion-panel"));
    if (!panels.length) return;
    const section = acc.closest(".btw-section") || document;
    const dots = Array.from(section.querySelectorAll(".step-dot"));

    let activeIndex = panels.findIndex((p) => p.classList.contains("active"));
    if (activeIndex < 0) activeIndex = 0;

    const setActive = (index) => {
        if (index === activeIndex) return;
        activeIndex = index;
        panels.forEach((p, i) => p.classList.toggle("active", i === index));
        dots.forEach((d, i) => d.classList.toggle("active", i === index));
    };

    panels.forEach((panel) => {
        const idx = parseInt(panel.getAttribute("data-index"), 10);
        panel.addEventListener("mouseenter", () => {
            if (window.innerWidth > 768) setActive(idx);
        });
        panel.addEventListener("click", () => setActive(idx));
    });

    dots.forEach((dot, i) => {
        const idx = parseInt(dot.getAttribute("data-index"), 10);
        dot.addEventListener("click", () => setActive(Number.isNaN(idx) ? i : idx));
    });
};

initQualityConstruction();
